import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconTags';
/** Renders an SVG icon. */
const SvgTags = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M18.537 26.02a1 1 0 0 1-1.366.366l-6.928-4a1 1 0 0 1-.366-1.366l6.166-10.681c.108-.187.275-.335.474-.42l7.356-3.142.957 7.942a1 1 0 0 1-.127.62l-6.166 10.68Zm7.898-9.681a3 3 0 0 0 .382-1.86l-.958-7.942a2 2 0 0 0-2.771-1.6L15.731 8.08a3 3 0 0 0-1.42 1.26L8.145 20.02a3 3 0 0 0 1.098 4.099l6.928 4a3 3 0 0 0 4.098-1.098l6.166-10.681Z"
      />
      <path
        fill="currentColor"
        d="M10.071 25.918a1 1 0 0 1-1.328-.487l-3.36-7.26a1 1 0 0 1 .487-1.327l8.394-3.887a1 1 0 0 0-.84-1.815L5.028 15.03a3 3 0 0 0-1.462 3.983l3.361 7.26a3 3 0 0 0 3.983 1.461l3.29-1.523-.84-1.815zm10.502-11.425a1 1 0 1 0-1.732-1 1 1 0 0 0 1.732 1m1.732 1a3 3 0 1 1-5.196-3 3 3 0 0 1 5.196 3"
      />
    </svg>
  );
};
SvgTags.displayName = displayName;
export default SvgTags;
